module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md8": "",
      "sm12": "",
      "xs12": ""
    }
  }, [(_vm.item.ManyAppInmuebleImage.length == 1) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "500px",
      "object-fit": "contain",
      "background": "#D9D9D9"
    },
    attrs: {
      "src": _vm.item.ManyAppInmuebleImage[0].description_source,
      "alt": "Imagen inmueble"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.item.ManyAppInmuebleImage.length > 1) ? _c('v-carousel', {
    attrs: {
      "icon": "stop"
    }
  }, _vm._l((_vm.item.ManyAppInmuebleImage), function(img, i) {
    return _c('v-carousel-item', {
      key: i
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "500px",
        "object-fit": "contain",
        "background": "#D9D9D9"
      },
      attrs: {
        "src": img.description_source,
        "alt": 'Imagen inmueble ' + (i + 1)
      }
    })])
  })) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "title grey--text text--darken-1 mt-5",
    domProps: {
      "innerHTML": _vm._s(_vm.item.desarrollo)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "sm12": "",
      "xs12": "",
      "pl-2": ""
    }
  }, [_c('h2', {
    staticClass: "display-2 text--darken-1"
  }, [_vm._v(_vm._s(_vm.item.description))]), _vm._v(" "), _c('v-chip', {
    staticClass: "lime accent-2 ",
    attrs: {
      "label": ""
    }
  }, [_vm._v(_vm._s(_vm.item.AppTipoOperacion.description))]), _vm._v(" "), (_vm.item.AppTipoMoneda && _vm.item.precio) ? _c('v-chip', {
    attrs: {
      "label": ""
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.item.AppTipoMoneda.codigo) + " " + _vm._s(_vm.item.precio.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")) + " ")])]) : _vm._e(), _vm._v(" "), _c('v-chip', {
    attrs: {
      "label": ""
    }
  }, [_vm._v(_vm._s(_vm.item.AppTipoPropiedad.singular) + " ")]), _vm._v(" "), (_vm.item.cantidad_dormitorios > 0) ? _c('v-chip', {
    staticClass: "grey lighten-4",
    attrs: {
      "label": "",
      "outline": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.item.cantidad_dormitorios) + "\n                "), (_vm.item.cantidad_dormitorios == 1) ? [_vm._v("Dormitorio")] : _vm._e(), _vm._v(" "), (_vm.item.cantidad_dormitorios > 1) ? [_vm._v("Dormitorios")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.item.cantidad_banios > 0) ? _c('v-chip', {
    staticClass: "grey lighten-4",
    attrs: {
      "label": "",
      "outline": ""
    }
  }, [_vm._v("\n               " + _vm._s(_vm.item.cantidad_banios) + "\n               "), (_vm.item.cantidad_banios == 1) ? [_vm._v("Baño")] : _vm._e(), _vm._v(" "), (_vm.item.cantidad_banios > 1) ? [_vm._v("Baños")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.item.cantidad_cocheras > 0) ? _c('v-chip', {
    staticClass: "grey lighten-4",
    attrs: {
      "label": "",
      "outline": ""
    }
  }, [_vm._v("\n\n               " + _vm._s(_vm.item.cantidad_cocheras) + "\n               "), (_vm.item.cantidad_cocheras == 1) ? [_vm._v("Cochera")] : _vm._e(), _vm._v(" "), (_vm.item.cantidad_cocheras > 1) ? [_vm._v("Cocheras")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-inmobiliaria-widget', _vm._b({
    attrs: {
      "item": _vm.item.Sucursal.Empresa
    }
  }, 'app-inmobiliaria-widget', _vm.item.AppInmuebleEstado.id != 1 ? {
    ribbon: _vm.item.AppInmuebleEstado.description
  } : {}, false)), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "overview"
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "divider thin"
  }), _vm._v(" "), (_vm.item.ManyAppTipoServicio.length) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', {
    staticClass: "display-1 mt-4"
  }, [_vm._v("Servicios")])]), _vm._v(" "), _vm._l((_vm.item.ManyAppTipoServicio), function(r, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "xs12": "",
        "md3": ""
      }
    }, [_c('v-chip', {
      staticClass: "lime lighten-4",
      attrs: {
        "label": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "dark": ""
      }
    }, [_vm._v("check_circle")]), _vm._v(" " + _vm._s(r.description) + "\n                            ")], 1)], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.item.ManyAppTipoInstalacion.length) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', {
    staticClass: "display-1 mt-4"
  }, [_vm._v("Instalaciones")])]), _vm._v(" "), _vm._l((_vm.item.ManyAppTipoInstalacion), function(r, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "xs12": "",
        "md3": ""
      }
    }, [_c('v-chip', {
      staticClass: "lime lighten-4",
      attrs: {
        "label": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "dark": ""
      }
    }, [_vm._v("check_circle")]), _vm._v(" " + _vm._s(r.description) + "\n                            ")], 1)], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.item.ManyAppTipoAmbiente.length) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', {
    staticClass: "display-1 mt-4"
  }, [_vm._v("Ambientes")])]), _vm._v(" "), _vm._l((_vm.item.ManyAppTipoAmbiente), function(r, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "xs12": "",
        "md3": ""
      }
    }, [_c('v-chip', {
      staticClass: "lime lighten-4",
      attrs: {
        "label": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "dark": ""
      }
    }, [_vm._v("check_circle")]), _vm._v(" " + _vm._s(r.description) + "\n                            ")], 1)], 1)
  })], 2) : _vm._e()], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c3015cd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppInmueble.vue
// module id = 81
// module chunks = 1